const nav = document.querySelector(".navigation");
const dropdowns = nav.querySelectorAll(".dropdown");
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".tiny-slideshow") !== null) {
    // let tnsFile = './tinySlider.js';
    // import(tnsFile).then(function(exports){
    //     let tns = exports.tns;
    let slideshows = document.querySelectorAll(".tiny-slideshow-wrapper");
    // let options = {
    //     mode: 'gallery',
    //     mouseDrag: true,
    //     nav: false
    // };
    let options = { loop: false };
    for (let slideshow of slideshows) {
      // options.container = slideshow.querySelector('.tiny-slideshow');
      // options.controlsContainer = slideshow.querySelector('.slideshow-controls');
      console.log(slideshow.dataset.options);
      if (slideshow.dataset.options !== "") {
        options = {
          ...options,
          ...JSON.parse(slideshow.dataset.options),
        };
        console.log(options);
      }
      // let slider = tns(options);
      const emblaApi = EmblaCarousel(
        slideshow.querySelector(".embla__viewport"),
        options
      );

      // Add click listeners
      slideshow
        .querySelector(".embla__prev")
        .addEventListener("click", emblaApi.scrollPrev, false);
      slideshow
        .querySelector(".embla__next")
        .addEventListener("click", emblaApi.scrollNext, false);
      if (emblaApi.slideNodes().length < 2){
        slideshow.querySelector('.slideshow-controls').remove();
      }; // Access API
    }
    // });
  }
  if (document.querySelector("#map") !== null) {
    let mapFile = "./location-map.js";
    import(mapFile).then(async function (exports) {
      let initMap = exports.initMap;
      await initMap();
    });
  }
  nav.querySelector(".menu-icon").addEventListener("click", function () {
    nav.classList.toggle("open");
    document.body.classList.toggle("nav-open");
  });
  
  for (let dropdown of dropdowns){
    dropdown.addEventListener("click", (e) => {
      if (e.target.tagName == 'A' && !e.target.parentNode.parentNode.classList.contains('child')){
        e.preventDefault();
      }      
      e.target.parentNode.querySelector("ul").classList.toggle('open');
    });
  }
});
document.addEventListener("scroll", function (ev) {
  if (window.scrollY > 42) {
    nav.classList.add("scrolled");
  } else {
    nav.classList.remove("scrolled");
  }
});
